import { useState } from 'react'
import { router } from '@inertiajs/react'
import { Globe2, Loader2 } from 'lucide-react'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

export interface BrowserEnvironmentSettings {
  enabled: boolean | null
  available: boolean
  copy: Record<'title' | 'description' | 'label' | 'detail' | 'unavailable', string>
}

interface Props {
  workerId: string
  settings: BrowserEnvironmentSettings
  canManage: boolean
}

export default function WorkerBrowserSettings({ workerId, settings, canManage }: Props) {
  const [saving, setSaving] = useState(false)
  const { copy } = settings
  return (
    <section className="space-y-4 rounded-xl border border-border bg-card p-5">
      <div className="flex items-center gap-2">
        <Globe2 className="h-4 w-4 text-muted-foreground" aria-hidden />
        <h2 className="text-[14px] font-semibold text-foreground">{copy.title}</h2>
        {saving && <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" aria-hidden />}
      </div>
      <p className="text-sm text-muted-foreground">{copy.description}</p>
      <div className="flex items-center justify-between gap-6">
        <div className="space-y-1">
          <Label htmlFor={`browser-${workerId}`}>{copy.label}</Label>
          <p className="text-xs text-muted-foreground">{settings.available ? copy.detail : copy.unavailable}</p>
        </div>
        <Switch
          id={`browser-${workerId}`}
          checked={settings.enabled === true}
          disabled={!canManage || saving || !settings.available}
          onCheckedChange={(enabled) => {
            setSaving(true)
            router.patch(`/dashboard/digital_workers/${workerId}/browser_environment`, { enabled }, {
              preserveScroll: true,
              onFinish: () => setSaving(false),
            })
          }}
        />
      </div>
    </section>
  )
}
